module.exports = __webpack_public_path__ + "static/media/img09.0acf22c7.JPG";